import React, { useState } from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputBooleanSwitch from "../../../../components/form/FormInputBooleanSwitch";
import CdoOpcCommand from "./CdoOpcCommand";
// INTERFACES
import {
	OpcMappingsInterface,
	OpcCmdToMessageInterface,
	OpcCommandType,
	ResponseContentTypesInterface,
	ReadContentTypesInterface,
	WriteContentTypesInterface,
	OpcCommand,
} from "../../../../../interfaces/AdapterCdoOpc.interface";

export default function CdoOpcMappingOpcCmdToMsg({
	setValue,
	opcMapping,
}: {
	setValue: (newValue: any) => void;
	opcMapping: OpcMappingsInterface;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [opcCmdToMessage, setOpcCmdToMessage] = useState<{
		command: OpcCommand;
		opcCommand: OpcCommandType;
		address: string;
		description: string;
		msg_id: string;
		active: boolean;
		position: number;
		responseContentType: ResponseContentTypesInterface;
		readContentType: ReadContentTypesInterface;
		writeContentType: WriteContentTypesInterface;
	}>({
		command: {},
		opcCommand: "read_content_table",
		address: "",
		description: "",
		msg_id: "",
		position: 0,
		active: true,
		responseContentType: "read_item_response",
		readContentType: "read_sync_item_message",
		writeContentType: "make_group",
	});

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const [t] = useTranslation("global");

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeOpcCmdToMsg = (
		newValue: string | boolean,
		variableName: any,
	) => {
		const copy = structuredClone(opcCmdToMessage);
		if (variableName === "address" && typeof newValue === "string") {
			copy.address = newValue;
		} else if (variableName === "msg_id" && typeof newValue === "string") {
			copy.msg_id = newValue;
		} else if (variableName === "description" && typeof newValue === "string") {
			copy.description = newValue;
		} else if (variableName === "active" && typeof newValue === "boolean") {
			copy.active = newValue;
		}
		setOpcCmdToMessage(copy);
	};

	const onClickAddNewOpcCmdMsg = () => {
		const newOpcCmdMessage: OpcCmdToMessageInterface = {
			key: {
				[opcCmdToMessage.opcCommand]:
					opcCmdToMessage.command.read_content_table ||
					opcCmdToMessage.command.response_content_table ||
					opcCmdToMessage.command.write_content_table,
			},
			value: {
				msg_id: opcCmdToMessage.msg_id,
				active: opcCmdToMessage.active,
				position: 0,
			},
		};
		const copy = structuredClone(opcMapping);
		copy.opc_cmd_to_msg.push(newOpcCmdMessage);
		setValue(copy);
		setOpcCmdToMessage({
			command: {},
			opcCommand: "read_content_table",
			address: "",
			description: "",
			msg_id: "",
			position: 0,
			active: true,
			responseContentType: "read_item_response",
			readContentType: "read_sync_item_message",
			writeContentType: "add_item",
		});
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<CdoOpcCommand
				setOpcCommand={setOpcCmdToMessage}
				opcCommand={opcCmdToMessage}
			/>
			<FormInputBooleanSwitch
				value={opcCmdToMessage.active}
				onChangeSwitch={onChangeOpcCmdToMsg}
				labelName={t("general.active")}
				variableName='active'
				isRequired
				
				disabledInput={false}
			/>
			<div className='col-md-12 mt-3'>
				<div className='generalStyles__flex'>
					<div className='generalStyles__inputFlexNameLarge'>
						<span className='generalStyles__inputFlexRequired' />
					</div>
					<div className='generalStyles__width100'>
						<Button
							onClick={onClickAddNewOpcCmdMsg}
							className='buttonStyle__28 generalStyles__width100'
						>
							<FontAwesomeIcon icon={faPlus} className='generalStyles__mrFix' />
							{t("general.add")}
						</Button>
					</div>
					<div className='generalStyles__infoTooltipIconBlank' />
				</div>
			</div>
		</div>
	);
}
